import { render, staticRenderFns, recyclableRender, components } from "./write-off.vue?vue&type=template&id=c3bb50b8&scoped=true&"
var renderjs
import script from "./write-off.vue?vue&type=script&lang=js&"
export * from "./write-off.vue?vue&type=script&lang=js&"
import style0 from "./write-off.vue?vue&type=style&index=0&id=c3bb50b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bb50b8",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pagesA/pages/write-off/write-off.vue"
export default component.exports